import { imgElement } from './elements/img.element';
import { linkElement } from './elements/link.element';
import { BrowserObjectModel } from '../components/browser-object-model';
import { Injectable } from '../components/dependency-injection/decorators';
import { StylesheetRenderer } from '../components/renderer/stylesheet.renderer';
import { AdSlotFormatSizeMap } from '../constants';
import { CreativeTypeEnum, LinkingTypeEnum } from '../dto/recs.dto';
import { AdSlotContainerItem } from '../entities/ad-slot-container-item';
import { CreativeViewInterface } from '../interfaces/containers/creative-view.interface';
import { HtmlElementContext } from '../types';

@Injectable()
export class ImageCreativeView implements CreativeViewInterface {
  public constructor (
    private readonly browserObjectModel: BrowserObjectModel,
    private readonly stylesheetRenderer: StylesheetRenderer,
  ) {
  }

  public render (item: AdSlotContainerItem): Element {
    const adSlot = item.getAdSlotContainer()?.getAdSlot();

    if (!adSlot) {
      throw new Error('AdSlot is required to render LinkCreativeView');
    }

    const itemElement = this.browserObjectModel.getDocument().createElement('null');
    const linkProperties = adSlot.getSettings().getLinkProperties();
    const linkingType = item.getLinkingType();
    const htmlElementContext: HtmlElementContext = {
      adSlot,
      dom: this.browserObjectModel.getDocument(),
      stylesheet: this.stylesheetRenderer.getStylesheet(adSlot),
    };

    const linkEl = linkElement({
      href: item.getUrl() ?? '',
      className: this.stylesheetRenderer.getClass(adSlot, 'listItemLink'),
      linkingType,
      attributes: {
        'data-id': item.getId(),
        'data-c-id': item.getCampaignId(),
        'data-p-id': item.getPublicationId(),
        'data-linking-type': linkingType?.toString(),
      },
      ...linkProperties[linkingType === LinkingTypeEnum.INTERNAL ? 'internal' : 'external'],
    }, htmlElementContext);

    const imgEl = imgElement({
      src: item.getCreative()?.fileResource.url,
      width: AdSlotFormatSizeMap[adSlot.getSettings().getFormat()].width,
      height: AdSlotFormatSizeMap[adSlot.getSettings().getFormat()].height,
      alt: item.getCreative()?.metadata?.alt,
      title: item.getTitle() ?? undefined,
      className: this.stylesheetRenderer.getClass(adSlot, 'listItemImg'),
    }, htmlElementContext);

    linkEl.appendChild(imgEl);
    itemElement.appendChild(linkEl);
    return itemElement;
  }

  public supports (item: AdSlotContainerItem): boolean {
    return item.getCreativeType() === CreativeTypeEnum.IMAGE;
  }
}
